import React from "react";
import { Routes, Route, useParams } from "react-router-dom";
import StageList from "./list";
import StageView from "./view";

export default function StageRouter({ job, setJob }) {
  return (
    <Routes>
      <Route index element={<StageList job={job} setJob={setJob} />} />
      <Route path=":stageId" element={<StageView job={job} setJob={setJob} />} />
    </Routes>
  );
}
